<div class="container">
  <div
    [ngClass]="date[0] ? 'holder border-active' : 'holder border-disable'"
    style="right: 0px"
  >
    <input
      type="tel"
      class="input"
      [(ngModel)]="date[0]"
      maxlength="2"
      (input)="checkActivatingButton(0)"
      id="input-0"
      placeholder="روز"
      (focus)="date[0] = ''"
    />
  </div>
  <div class="slash" style="right: 40px">/</div>
  <div
    [ngClass]="date[1] ? 'holder border-active' : 'holder border-disable'"
    style="right: 60px"
  >
    <input
      type="tel"
      class="input"
      [(ngModel)]="date[1]"
      maxlength="2"
      (input)="checkActivatingButton(1)"
      (keyup)="keytab($event, 1)"
      id="input-1"
      placeholder="ماه"
      (focus)="date[1] = ''"
    />
  </div>
  <div class="slash" style="right: 102px">/</div>
  <div
    [ngClass]="
      date[2]
        ? 'holder-year border-active'
        : showYearPrefix
        ? 'holder-year border-disable'
        : 'holder border-disable'
    "
    style="right: 120px"
  >
    <input
      type="tel"
      class="input"
      [(ngModel)]="date[2]"
      maxlength="2"
      (input)="checkActivatingButton(2)"
      (keyup)="keytab($event, 2)"
      (focus)="activateYearPrefix(); date[2] = ''"
      (blur)="disableYearPrefix()"
      id="input-2"
      placeholder="سال"
    />
    <div class="input-title" *ngIf="showYearPrefix">۱۳</div>
  </div>
</div>
<div *ngIf="hasError" class="error-title">تاریخ وارد شده اشتباه است</div>
